<sc-flex fitHeight stretchContent>
  <div class="info-column">
    <sc-flex vertical stretchContent>
      <div class="icon-container">
        <i class="fa-light fa-sharp fa-check-circle"></i>
      </div>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.numberPlate" [value]="numberPlate"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.driver" [value]="driver"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.carrier" [value]="carrier"></sc-read-only-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-read-only-field labelDictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.referenceNumber" [value]="orderReference"></sc-read-only-field>
    </sc-flex>
  </div>
  <sc-content-spacer [double]="true"></sc-content-spacer>
  <sc-flex-fitting-content>

    @if (showSelectedOptions) {
      @for (option of selectedOptions; track option) {
        <div class="option">
          <sc-padding>
            <sc-dictionary-label [dictionaryKey]="option"></sc-dictionary-label>
          </sc-padding>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
      }
    }

    @if (gatekeeperMandatory) {
      <div class="gatekeeper-hint">
        <sc-padding>
          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.hint"></sc-dictionary-label>
        </sc-padding>
      </div>
      <sc-content-spacer vertical></sc-content-spacer>
    }

    @if (isUsingSmartphone) {
      <div class="smartphone-hint">
        <sc-padding>
          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.description"></sc-dictionary-label>
        </sc-padding>
      </div>
      <sc-content-spacer vertical></sc-content-spacer>
    }

    @for (hint of hintDrivers; track hint) {
      <div class="driver-hint">
        <sc-padding>
          <sc-dictionary-label [dictionaryKey]="hint"></sc-dictionary-label>
        </sc-padding>
      </div>
      <sc-content-spacer vertical></sc-content-spacer>
    }

  </sc-flex-fitting-content>
</sc-flex>
